// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	BackToIntegrationsButton: 'back-to-integrations-button',
} as const;
